import { ReactElement } from 'react';

import type { Placement } from '@popperjs/core';
import styled from 'styled-components';

import { IconInfoSmall } from '@components/icons/info-small';
import { Tooltip } from '@components/tooltip';
import { theme } from '@styles/theme';

type InfoTooltipProps = {
  tooltip: string | ReactElement;
  placement?: Placement;
};

export function InfoTooltip({ tooltip, placement }: InfoTooltipProps) {
  if (typeof tooltip === 'string' && !placement) {
    return (
      <Container>
        <IconInfoSmall color="elementPurple50" tooltip={tooltip} />
      </Container>
    );
  }

  return (
    <Tooltip placement={placement} content={tooltip}>
      <Container>
        <IconInfoSmall color="elementPurple50" />
      </Container>
    </Tooltip>
  );
}

const Container = styled.span({
  display: 'flex',
  svg: {
    ':hover': {
      color: theme.color.elementIndigo100,
    },
  },
});
